
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 3.25a.75.75 0 01.75.75v9.454a.75.75 0 01-1.5 0V4a.75.75 0 01.75-.75z"}}),_c('path',{attrs:{"d":"M6.582 9.367a.75.75 0 011.06.023l2.86 2.98 2.858-2.98a.75.75 0 111.082 1.038l-3.4 3.545a.75.75 0 01-1.082 0l-3.4-3.545a.75.75 0 01.022-1.06z"}}),_c('path',{attrs:{"d":"M2 12.705a.75.75 0 01.75.75v1.181c0 .438.167.852.455 1.153.287.299.67.461 1.062.461h12.466a1.47 1.47 0 001.062-.461c.288-.3.455-.715.455-1.153v-1.181a.75.75 0 011.5 0v1.181c0 .816-.31 1.605-.873 2.19a2.97 2.97 0 01-2.144.924H4.267a2.97 2.97 0 01-2.144-.923 3.166 3.166 0 01-.873-2.19v-1.182a.75.75 0 01.75-.75z"}})])
          )
        }
      }
    